<template>
  <div>
    <search-comp
      :non-border="true"
      :search-show="true"
      @onSearch="onSearch"
      @onReset="onReset"
    >
      <div class="section-box">
        <validation-observer ref="priceCodeFormValidator">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-group-title">Mã giá</div>
              <hr />
              <div class="das-form-row">
                <div class="das-form-col col-4">
                  <validation-provider
                    rules="required"
                    :name="$t('validator.priceCode')"
                  >
                    <div class="das-form-input">
                      <div class="label required">Mã giá</div>
                      <el-select
                        v-model="searchParams.id"
                        placeholder=""
                        @change="onPriceCodeChange($event)"
                      >
                        <el-option
                          v-for="item in priceCodeOptions"
                          :key="item.id"
                          :label="item.code"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </validation-provider>
                </div>
                <div class="das-form-col col-4">
                  <div class="das-form-input">
                    <div class="label">Tiền tệ</div>
                    <div class="child-w-80">
                      <input
                        type="text"
                        style="background: #f0f0f5 !important"
                        :value="searchParams.currency_code"
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div v-show="false">
                  <validation-provider
                    rules="required"
                    name="Ngày bắt đầu của mã giá"
                  >
                    <input v-model="searchParams.startDt" />
                  </validation-provider>
                  <validation-provider
                    rules="required"
                    name="Ngày kết thúc của mã giá"
                  >
                    <input v-show="false" v-model="searchParams.endDt" />
                  </validation-provider>
                </div>
                <div class="das-form-col col-4">
                  <div class="das-form-input">
                    <div class="label required">Ngày</div>
                    <CalendarRange
                      v-model="priceCodePeriod"
                      style="display: block"
                      mode="date"
                    />
                  </div>
                </div>
              </div>
              <div class="das-form-row">
                <div class="das-form-col col-12">
                  <div class="das-form-input">
                    <div class="label">Mô tả</div>
                    <div class="child-w-80">
                      <textarea
                        :rows="2"
                        type="text"
                        :value="searchParams.desc"
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <!-- <div class="das-form-col col-8">
                  <div class="das-form-input">
                    <div class="label">Trạng thái</div>
                    <div class="checkbox-container">
                      <div class="checkbox-wrap read-only">
                        <input
                          id="cpSpdTp3"
                          type="checkbox"
                          :checked="searchParams.daily_price"
                          :value="searchParams.daily_price"
                          :readonly="true"
                        />
                        <label for="cpSpdTp3">Gồm bữa ăn</label>
                      </div>
                      <div class="checkbox-wrap read-only">
                        <input
                          id="cpSpdTp2"
                          type="checkbox"
                          :checked="!searchParams.nett"
                          :value="!searchParams.nett"
                          readonly
                        />
                        <label for="cpSpdTp2">Giá không bao gồm thuế phí</label>
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </validation-observer>
      </div>
    </search-comp>
  </div>
</template>

<script>
export default {
  data() {
    return {
      priceCodePeriod: {},
      priceCodeOptions: [],
      searchParams: {
        id: null,
        code: null,
        price_category_id: null,
        price_category_code: null,
        order: null,
        currency_code: null,
        nett: null,
        desc: null,
        startDt: null,
        endDt: null
      }
    }
  },
  watch: {
    priceCodePeriod(data) {
      this.searchParams.startDt = data.start || null
      this.searchParams.endDt = data.end || null
    }
  },
  mounted() {
    this.getPriceCodeOptions()
  },
  methods: {
    async onSearch() {
      if (
        (await this.$vxForm.isValid(this.$refs.priceCodeFormValidator)) ===
        false
      ) {
        return
      }
      this.$emit('onSearch', this.searchParams)
    },
    onReset() {
      this.priceCodePeriod = {}
      this.searchParams = {
        id: null,
        code: null,
        price_category_id: null,
        price_category_code: null,
        order: null,
        currency_code: null,
        nett: null,
        desc: null,
        startDt: null,
        endDt: null
      }
      this.$emit('onSearch', this.searchParams)
    },
    onPriceCodeChange(id) {
      const rowData = this.priceCodeOptions.filter(
        // eslint-disable-next-line eqeqeq
        item => item.id == this.searchParams.id
      )
      Object.assign(this.searchParams, rowData[0])
    },
    getPriceCodeOptions() {
      this.$axios
        .get('/config-service/v1/hotel/price-code', {
          params: {
            isDailyPrice: true
          }
        })
        .then(res => {
          this.priceCodeOptions = res.data
        })
    }
  }
}
</script>
